var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 494.06 450.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.35,24.22A146.49,146.49,0,0,0,247,40,146.43,146.43,0,0,0,42.88,42.88h0a146.43,146.43,0,0,0-2.82,204.17c-.12.12,38.58,38.94,82.54,82.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.58,66.85,165,372.4c33.6,33.57,64,63.93,76.29,76a8.12,8.12,0,0,0,11.41,0C286,415.47,454.22,247.27,454,247A146.48,146.48,0,0,0,470.58,66.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.297aa6c864fa9146cc3dd1791a129cbd.svg";
export { ForwardRef as ReactComponent };